package common.dto

import kotlinx.serialization.Serializable

/**
 * A rotation around a [Line3d] by a certain angle. This is used to e.g. rotate a brick around
 * the edge of a Brixi.
 *
 * @param line The line around which the rotation is performed. Like an axis with an origin.
 * @param angle The angle in radians by which the rotation is performed.
 */
@Serializable
data class RotationAround(
    val line: Line3d,
    val angle: Double
)

infix fun Double.around(line: Line3d) = RotationAround(line, this)
fun Double.aroundX() = RotationAround(Line3d.X_AXIS, this)
fun Double.aroundY() = RotationAround(Line3d.Y_AXIS, this)
fun Double.aroundZ() = RotationAround(Line3d.Z_AXIS, this)
